import Tag from '../../../../../../shared/Tags/Tag'
import { IMaintenanceProcessRule } from '../../../maintenance.types.ts'
import maintenanceProcessesUtils from '../../maintenanceProcesses.utils.ts'

interface IProps {
  periods: Array<IMaintenanceProcessRule['period']>
}

const MaintenanceProcessPeriodsTags = (props: IProps) => {
  return (
    <div className="inline-flex-gap gap8 flex-wrap">
      {props.periods.map((period) => (
        <Tag color="gray">{maintenanceProcessesUtils.getPeriodName(period)}</Tag>
      ))}
    </div>
  )
}

export default MaintenanceProcessPeriodsTags
